"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useZoomPercentage = () => {
  const [zoomPercentage, setZoomPercentage] = (0, _react.useState)(100);
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      const outerWidth = window.outerWidth;
      const innerWidth = window.innerWidth;
      setZoomPercentage(Math.round(outerWidth / innerWidth * 100));
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return zoomPercentage;
};
var _default = exports.default = useZoomPercentage;